import { memo, useMemo } from 'react';
import { Box, Loader, WebView } from '@betty/moonlight';
import { DepositLaunchProps } from './DepositLaunch.types';
import usePaymentLaunch from '../../hooks/usePaymentLaunch';

function DepositLaunch({ amount }: DepositLaunchProps) {
  const data = useMemo(() => ({ depositAmount: amount }), [amount]);
  const options = usePaymentLaunch('deposit', data);

  if (!options.source) {
    return (
      <Box flex={1} centerContent>
        <Loader />
      </Box>
    );
  }

  return (
    <WebView
      style={{ paddingHorizontal: 4, backgroundColor: 'transparent' }}
      {...options}
    />
  );
}

export default memo(DepositLaunch);
